
type LinkedListProps = {
    list : JSX.Element[] | string[] | any[];
}

const LindedList = ({ list } : LinkedListProps) => {
  return (
    <div className="lined-list">
        {list.map((item, index) => (
            <div key={index} className="list-item">
                {item}
            </div>
        ))}
    </div>
  )
}

export default LindedList